import { PageProps } from '@react-pdf/renderer'

import { ProfitAndLossReportOptions } from '@features/reports/views/NL/profitAndLossReport/contexts/profitAndLossFiltersContext'

export const getProfitAndLossPageOrientation = (filters: ProfitAndLossReportOptions): PageProps['orientation'] => {
  const requiresWideLayout = filters?.showChange || filters?.showGroupPercentage

  return requiresWideLayout ? 'landscape' : 'portrait'
}
